import React from "react";
import PageHeader from "../Components/PageHeader";

function About() {
  return (
    <div>
      <PageHeader title={"Om oss"} width={"960px"} />
      <section className="section px-4">
        <div className="mx-auto max-w-[960px]">
          <p className="mb-8 font-bold">
            När började människan skapa och lyssna på musik? När blev musiken
            ett njutningsmedel, för kontemplation, för dans, verklighetsflykt,
            för glädje och tröst? Kanske har forskarna inget definitivt svar på
            frågan. Men Göteborgarna vet i alla fall när en av deras absoluta
            favoritstationer – Radio 88 – drog igång med sin musik. Året var
            2004. Men historien om Radio 88 går längre tillbaks än så.
          </p>
          <p className="mb-8">
            Partille Närradio, där Radio 88 ingår, startade sina sändningar i
            mitten av 1980-talet. Som alltid när det gäller föreningsverksamhet
            var den beroende av eldsjälar. I detta fall hette de Sven Olofson
            och Leif Andersson. När de drog igång sändningar var det med enklast
            tänkbara teknik.
          </p>
          <p className="mb-8">
            Sändningarna uppgick till några få timmar i veckan. Ljudet gick på
            en telefontråd via televerkets telestation upp till sändaren. Stereo
            var det inte tal om, allt sändes i mono. Och när det inte sändes
            musik hördes istället en intalad slinga eller en kort hemsk
            elektronisk musiksnutt. Lyssnarna stängde snabbt av…
          </p>
          <h2 className="mt-16 mb-8">Musiken</h2>
          <p className="mb-8">
            Tio år senare, på 1990-talet, började Partille Närradio att spela
            musik på dagarna. Föreningen som sände hette Radio FM och
            stationschef var Tony Eriksson. Verksamheten började försiktigt med
            några få timmars sändning per vecka. Men i takt med ökade
            reklamintäkter (det blev tillåtet med reklam i närradion 1996)
            började man sända hela dagar. På natten var det pausfiskar, alltså
            helt tyst. Men när datorerna gjorde det lite enklare att spela musik
            obemannat, ja då rullade musiken på – dygnet runt! Musikälskarna
            applåderade.
          </p>
          <article className="mb-8 sm:flex items-center bg-primary">
            <div className="sm:p-8 p-4">
              <h2 className="sm:mb-8 leading-tight text-accent">
                Några av programledarna från Radio FM tiden
              </h2>
              <p>
                Från vänster; Johnny, Philip, Dick och Torsten. Johnny och
                Torsten är fortfarande radioaktiva hos oss på Radio 88.
              </p>
            </div>
            <div>
              <img
                src="/images/image.webp"
                alt="programledarna från Radio FM tiden"
              />
            </div>
          </article>
          <h2 className="mt-16 mb-8">Åren gick</h2>
          <p className="mb-8">
            Radio FM blev allt populärare men år 2004 tvingades man ändå lägga
            ned. Där kunde historien slutat. Men några av programledarna från
            Radio FM vägrade ge upp. De bildade en ny ideell förening – Radio 88
            föddes. Namnet tog man logiskt nog från den frekvens Partille
            Närradio sänder över, alltså 88 Mhz, någon millimeter eller två till
            vänster om Sveriges Radio P1 på frekvensskalan.
          </p>
          <p className="mb-8">
            Ny era Nu inleddes en mer dynamisk period. Med sällsynt hängivna
            musik- och radioälskande eldsjälar har tekniken förfinats samtidigt
            som det redaktionella utbudet ökat väsentligt. I detta sammanhang
            kan man inte nog betona den viktiga roll Ulf Ligander hade under
            många år. Ända till sin bortgång 2011 var Ulf djupt engagerad i
            teknik och programutbud.
          </p>
          <article className="sm:flex items-center bg-primary">
            <div>
              <img src="/images/image (1).webp" alt="Programledare från 2012" />
            </div>
            <div className="p-4 sm:p-8">
              <h2 className="mb-4 sm:mb-8 leading-tight text-accent">
                Så här kan det också se ut när man sänder radio live
              </h2>
              <p className="sm:mb-8">
                Johanna Bergqvist (med praktikanten Emily Mervik i knät) samt
                Mats Adelin i bakgrunden 2012.
              </p>
            </div>
          </article>
          <h2 className="mt-16 mb-8">Radio 88 idag</h2>
          <p className="mb-8">
            Idag drivs Radio 88 av ett 35-tal programledare/tekniker/säljare där
            drivkraften är det breda och djupa musikintresset. Fokus ligger
            dagtid på hits från förr, men även på ny musik som passar in i
            formatet. Kvällarna kan vara mer specialiserade med innehåll från
            olika genrer. Ingen musik är förbjuden om känslan är den rätta men i
            princip är det pop, rock, country, schlager, reggae, visor och
            dansband som gäller.
          </p>
          <p className="mb-8">
            På dagtid är rättesnöret att 70 procent av musikutbudet är äldre
            hits med en hög igenkänningsfaktor. Resterande 30 procent kan vara
            programledarens egna favoriter eller musik som passar in, men som
            nödvändigtvis inte definieras som självklara hits.
          </p>
          <p className="mb-8">
            En stor del av radions utbud består av redaktionellt producerade
            livesändningar med programledare i studion. De ägnar varje år
            tusentals timmar åt att förbereda sig, sända, lägga upp spellistor,
            genomföra tävlingar och bjuda in intressanta gäster, företrädesvis
            artister inom musikbranschen.
          </p>
          <p className="mb-8">
            Övrig tid sänds inspelade program eller melodiradio. Varje hel timma
            sänds välproducerade nyheter och väderrapporter.
          </p>
          <p className="mb-8">
            En viktig del för radions framgång är aktiva och lyhörda
            lyssnarkontakter. Bland annat via radions speciella supporterklubb
            och det populära önskeprogrammet Aladdin som sänds två gånger i
            veckan. Radions prioriterade målgrupp är 40+.
          </p>
          <p className="mb-8">
            Radio 88 ingår som en av flera föreningar (och den absolut största)
            i Partille Närradio. Studion ligger i Sävedalen, Partille. Här finns
            idag en avancerad teknik i framkant jämfört med många andra
            radiostationer.
          </p>
          <p className="mb-8">
            Radiofrekvensen är FM 88,0 MHz och når ut till lyssnare i Partille
            och hela Göteborgsområdet. Via webbradion på www.radio88.se eller
            via radioappar når Radio 88 lyssnare i hela världen. Radio 88 har
            många trogna lyssnare, inte bara i Göteborgsområdet.
          </p>
          <p className="mb-8">
            Det mesta av den sända musiken kommer från Radio 88:s eget digitala
            musikarkiv. Arkivet är så omfattande att det brukar dröja länge
            innan en låt sänds en andra gång. Till skillnad mot många andra
            radiostationer spelas musik även från vinyl- och CD-skivor och från
            andra källor.
          </p>
          <p className="mb-8">
            Radio 88 är reklamfinansierad och sänder musik dygnet runt. På
            helgerna använder andra föreningar frekvensen. Då sänds t ex
            kommuninformation och gudstjänster. Dessa sändningar subventioneras
            av Radio 88:s intäkter.
          </p>
          <div className="bg-primary p-8 text-black">
            <h2 className="mb-8 mt-8 leading-tight text-accent">
              Radiofrekvensen är FM 88,0 MHz och når ut till lyssnare i Partille
              och hela Göteborgsområdet.
            </h2>
            <p className="mb-8">
              Via webbradion på www.radio88.se eller via radioappar når Radio 88
              lyssnare i hela världen. Radio 88 har många trogna lyssnare, inte
              bara i Göteborgsområdet.
            </p>
          </div>
          <h2 className="mt-16 mb-8">Kort historik</h2>
          <p className="mb-8">
            <span className="font-bold">Början av 80-talet</span> – Partille
            Närradio bildas av bland andra eldsjälen Leif Andersson
          </p>
          <p className="mb-8">
            <span className="font-bold">Mitten av 90-talet</span> – Musik
            började sändas några timmar varje dag
          </p>
          <p className="mb-8">
            <span className="font-bold">Slutet av 90-talet</span> – Radio FM som
            var föregångaren till Radio 88 startade
          </p>
          <p className="mb-8">
            <span className="font-bold">2004</span> – Radio FM ombildas av
            femton programledare till Radio 88 och till sin nuvarande form och
            inriktning
          </p>
          <p className="mb-8">
            <span className="font-bold">2012</span> – Radio 88 får egen ekonomi,
            skild från Partille Närradioförening
          </p>
          <p className="mb-8">
            <span className="font-bold">2014</span> – Radio 88 fyller tio år
          </p>
          <p className="mb-8">
            <span className="font-bold">2016</span> – Radio 88 Partille byter
            namn till Radio 88.
          </p>
        </div>
      </section>
    </div>
  );
}

export default About;
